<sub-header [isModal]="true" [windowHash]=windowHash [includeContextHelp]="false"></sub-header>
  <div class="container-fluid " *ngIf="isLoaded()">
    <div class="row">
      <div class="col-12">
        <p-panel [toggleable]="true" [collapsed]="false">
          <p-header>
            <span> <i class="fa fa-file" aria-hidden="true"></i> {{'General.filters'|translate}}</span>
          </p-header>
          <div class="col-12 ">
            <formPlyca #formPlycaRef1 [formConfig]="formConfig1" *ngIf="formConfig1" [manageWaitService]=false>
            </formPlyca>
          </div>
          <div class=" col-12 text-right ">
            <button class="btn btn-sm btn-secondary" (click)="this.clearFilter()"
              title="{{ 'General.reset.filters' | translate}}">
              <i class="fas fa-undo" aria-hidden="true"></i> <span> {{ 'General.reset.filters' | translate}}</span>
            </button>
          </div>
        </p-panel>
      </div>
    </div>
    <div class="row m-t-md">
      <div class="col-12">
        <p-panel [toggleable]="false" [collapsed]="false" [styleClass]="' scroll-x'">
          <p-header>
            <span class="label label-default float-right">{{ 'Tasks.showing' | translate }} {{elements ? elements.length
              : '0'}} </span>
          </p-header>

          <div class="row">
            <div class="col-12 ">
              <div class="alert alert-info col-12" role="alert" *ngIf="!elements || elements.length===0">
                <span style="line-height: 2em;"><i class="fa fa-1-5x fa-info-circle mr-2" aria-hidden="true"></i>{{
                  'General.noData' | translate }}</span>
              </div>

              <p-table [value]="filteredElements" [rows]="defaultNumberRows" [paginator]="true" [pageLinks]="4"
                [rowsPerPageOptions]="rowsPerPageOptions" [responsive]="false" class="col-12" dataKey="identifier"
                editMode="row" [first]="lastPageFirstRecordIndex" (onPage)="onPageChange($event)">


                <ng-template pTemplate="header">
                  <tr>

                    <th pSortableColumn="lot.lotId" class="TEXTTH-w100">Lote <p-sortIcon field="lot.lotId">
                      </p-sortIcon>
                    </th>
                    <th pSortableColumn="group" class="TEXTTH-w100 th-wrap">
                      Grupo <p-sortIcon field="group">
                      </p-sortIcon>
                    </th>
                    <th pSortableColumn="internalCode" class="TEXTTH-w200   th-wrap ">Código
                      <p-sortIcon field="internalCode">
                      </p-sortIcon>
                    </th>
                    <th pSortableColumn="description" class="TEXTTH-w200   th-wrap ">Descripción <p-sortIcon
                        field="description">
                      </p-sortIcon>
                    </th>
                    <th pSortableColumn="complementaryOne" class="TEXTTH-w200  th-wrap">
                      Descripcion adicional (1)
                      <p-sortIcon field="complementaryOne">
                      </p-sortIcon>
                    </th>
                    <th pSortableColumn="complementaryTwo" class="text-right TEXTTH-w200  th-wrap">
                      Descripcion
                      adicional (2) <p-sortIcon field="complementaryTwo">
                      </p-sortIcon>
                    </th>
                    <th pSortableColumn="amountExcludingTaxes" class="CURRENCYTH  th-wrap "> P.Unitario sin IVA
                      <p-sortIcon field="amountExcludingTaxes">
                      </p-sortIcon>
                    </th>
                    <th pSortableColumn="taxType.description" class="text-right TEXTTH-w200  th-wrap ">Tipo IVA
                      <p-sortIcon field="taxType.description">
                      </p-sortIcon>
                    </th>
                    <th class=" action-column-2"></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-element let-editing="editing" let-ri="rowIndex">
                  <tr [pEditableRow]="element">
                    <td class="TEXTTH-w100" *ngIf="this.showLotes">
                      <formatDataValue [type]="'TEXT'"
                        [value]="element?.lot?.lotNumber?element.lot.lotNumber: element?.lot?.lotId === 0?'0':''">
                      </formatDataValue>
                    </td>
                    <td class="TEXTTH-w100" *ngIf="!this.showLotes">
                      <formatDataValue [type]="'TEXT'" [value]="'0'">
                      </formatDataValue>
                    </td>
                    <td class="TEXTTH-w100">
                          <formatDataValue [type]="'TEXT'" [value]="element.group?element.group:''">
                          </formatDataValue>
                    </td>
                    <td class="TEXTTH-w100 ">
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <formElement [model]="element" [fieldConfig]="getFieldConfig('internalCode')">
                          </formElement>
                        </ng-template>
                        <ng-template pTemplate="output">
                          <formatDataValue [type]="'TEXT'" [value]="element.internalCode?element.internalCode:''">
                          </formatDataValue>
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="TEXTTH-w200 ">
                          <formatDataValue [type]="'TEXT'" [value]="element.description?element.description:''">
                          </formatDataValue>
                    </td>
                    <td class="TEXTTH-w200">
                          <formatDataValue [type]="'TEXT'"
                            [value]="element?.complementaryOne?element?.complementaryOne:''">
                          </formatDataValue>
                    </td>
                    <td class="TEXTTH-w200">
                          <formatDataValue [type]="'TEXT'"
                            [value]="element?.complementaryTwo?element?.complementaryTwo:''">
                          </formatDataValue>
                    </td>
                    <td class="CURRENCYTH" *ngIf="this.procurementprojectLot && !this.procurementprojectAM">
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <formElement [model]="element" [fieldConfig]="getFieldConfig('amount')">
                          </formElement>
                        </ng-template>
                        <ng-template pTemplate="output">
                          <formatDataValue [type]="'INTEGER'" [value]="element?.amount?element?.amount:0">
                          </formatDataValue>
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="CURRENCYTH">
                      <formatDataValue [type]="'CURRENCY'"
                        [value]="element.amountExcludingTaxes?element.amountExcludingTaxes:0" [maxDecimals]="4">
                      </formatDataValue>
                    </td>
                    <td class="TEXTTH-w200 text-right">
                      <formatDataValue
                        [value]="element?.taxType?.properties?.DESCRIPCION?element.taxType.properties.DESCRIPCION:''">
                      </formatDataValue>
                    </td>


                    <td class="action-column-2">
                      <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                          pTooltip="Editar" (click)="onRowEditInit(element, ri)"
                          class="p-button-rounded p-button-text"></button>

                          <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                          pTooltip="Confirmar edición" (click)="onRowEditSave(element,ri)"
                          class="p-button-rounded p-button-text"></button>

                          <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                          pTooltip="Cancelar edición" (click)="onRowEditCancel(element, ri)"
                          class="p-button-rounded p-button-text"></button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </p-panel>
      </div>
    </div>
  </div>




  <!-- <div class="container-fluid m-t-sm" *ngIf="isLoaded()"> -->
  <!-- <div class="row">
    <div class="col-12 m-b-md">
      <div class="titleElement"> Datos básicos del Contrato
      </div>
    </div>
    <div class="col-12 m-b-md">
      <dl class="col-12 p-0 m-0">
        <dt class="col-12 col-md-2 d-inline-block">{{ 'Propuesta' | translate }}</dt>
        <dd class="col-12 col-md-4 d-inline-block">{{ (model?.dto?.division?.project?.identifier) ?
          (model?.dto?.division?.project?.identifier).
          substring(0,4) + '/' + (model?.dto?.division?.project?.identifier).substring(4): ''}}</dd>
      </dl>
      <dl class="col-12 p-0 m-0">
        <dt class="col-12 col-md-2 d-inline-block">{{ 'Objeto del Contrato ' | translate }}</dt>
        <dd class="col-12 col-md-10 d-inline-block">{{ model.ui.contractDescription }}</dd>
        <dt class="col-12 col-md-2 d-inline-block">{{ 'Adjudicatario' | translate }}</dt>
        <dd class="col-12 col-md-10 d-inline-block">{{ model.ui.awardDescription }}</dd>
      </dl>
    </div>
  </div> -->
  <!-- </div>  -->
